module.exports = __webpack_public_path__ + "static/media/brands-08-home@2x.5dcd6881.png";